import {CenteredSpinner, Wrapper} from './styled';

export function PageCenteredSpinner() {
    return (
        <Wrapper>
            <CenteredSpinner />
        </Wrapper>
    );
}
